import React, { useState, useEffect, FC } from 'react';
import KickImage from 'Reuseables/KickImage';
import { withRouter } from "react-router-dom"
import { connect } from "react-redux"
import ProductSlider from "./Helpers/ProductSlider"
import ProductSliderType2 from "./Helpers/ProductSliderType2"
import { getCollectionList } from "../../../actions/kafairAction"
import LouisVuittonImage from "../../../images/louis-vuitton.jpg"
import Kobe5Proto from "../../../images/kobe-5-protro.jpg"
import AdidasNmdHu from "../../../images/adudas-nmd-hu.jpg"
import SneakerEssentialz from "../../../images/sneaker-essential.jpg"
import SneakersEssentialzMobile from "../../../images/essentials-collection_mobile.png"
import KobeMobile from "../../../images/kobe-collection_mobile.png"
import LvCollectionMobile from "../../../images/lv-collection_mobile.png"
import NmdCollectionMobile from "../../../images/nmd-collection_mobile.png"

interface History {
  push: (args: string) => any;
  replace: (args: string) => any;
}

type CollectionPage = {
  category: string;
  title: string;
  history: History;
  getCollectionList(args: string, slug: string, payload: Object, name: string): any;
  slug: string
}

const CollectionPage: FC<CollectionPage> = ({ category, title, history, getCollectionList, slug }) => {

  const [dataProducts, setDataProducts] = useState([])
  const [collectionId, setCollectionId] = useState(null);

  useEffect(() => {
    if (slug) {
      let payload = {
          availables: true,
          per_page: 11,
          page: 1
      };

      let name = slug.replace("-", "_")

      title && getProductData(category, slug, payload, name);
    }
  }, [slug])

  async function getProductData(category: string, slug: string, payload: Object, name: string) {
    try {
      let { value } = await getCollectionList(category, slug, payload, name)
      setCollectionId(value?.data?.id ?? null)
      setDataProducts(value.data.products.data)
    } catch (e) {
      return null
    }
  }

  function checkHeaderImage() {
    if (window.screen.availWidth > 480) {
      if (title === 'NIKE Kobe 5 Protro “Bruce Lee”') {
        return Kobe5Proto
      } else if (title === 'ADIDAS NMD Hu “Extra Eye”') {
        return AdidasNmdHu
      } else if (title === "SNEAKERS ESSENTIALS") {
        return SneakerEssentialz
      } else {
        return LouisVuittonImage
      }
    } else {
      if (title === 'NIKE Kobe 5 Protro “Bruce Lee”') {
        return KobeMobile
      } else if (title === 'ADIDAS NMD Hu “Extra Eye”') {
        return NmdCollectionMobile
      } else if (title === "SNEAKERS ESSENTIALS") {
        return SneakersEssentialzMobile
      } else {
        return LvCollectionMobile
      }
    }
  }

  function checkHeaderBrand() {
    if (window.screen.availWidth > 480) {
      if (title === 'NIKE Kobe 5 Protro “Bruce Lee”') {
        return "NIKE"
      } else if (title === 'ADIDAS NMD Hu “Extra Eye”') {
        return "ADIDAS"
      } else if (title === "SNEAKERS ESSENTIALS") {
        return null
      } else {
        return "LOUIS VUITTON"
      }
    } else {
      return null
    }
  }

  function checkHeaderTitle() {
    if (title === 'NIKE Kobe 5 Protro “Bruce Lee”') {
      return 'Kobe 5 Protro “Bruce Lee"'
    } else if (title === 'ADIDAS NMD Hu “Extra Eye”') {
      return 'NMD Hu "Extra Eye"'
    } else if (title === "SNEAKERS ESSENTIALS") {
      return "SNEAKERS ESSENTIALS"
    } else {
      return "SS21 COLLECTION"
    }
  }

  function navigate(url: string) {
    history.push(url)
  }

  return (
    <div className="collectionList-page">
      <div style={{ backgroundImage: `url(${title && checkHeaderImage()})` }} className="collectionList-header">
        <h4>{checkHeaderBrand()}</h4>
        {
          window.screen.availWidth > 480 &&
          <h6>{checkHeaderTitle()}</h6>
        }
      </div>
      {
        title && title !== "SNEAKERS ESSENTIALS" ?
          <div style={{padding: "0px 40px 0px 40px"}}>
            <ProductSlider
              dataProducts={dataProducts}
              title={title}
              activeBrowseAll
              chosenOption={title}
              navigate={navigate}
              navigateUrl={`/${category}/collection/${slug}`}
              collectionId={collectionId}
            />
          </div> :
          <div style={{padding: "0px 40px 0px 40px"}}>
            <ProductSliderType2
              options={["Sneakers Box", "Shoelace", "Spray"]}
              history={history}
              category={category}
              collectionId={collectionId}
            />
          </div>
      }
    </div>
  )
}

const mapDispatchToProps = (dispatch: any) => ({
  getCollectionList: (category: string, slug: string, payload: Object, name: string) => dispatch(getCollectionList(category, slug, payload, name))
})

export default connect(null, mapDispatchToProps)(withRouter(CollectionPage))
